module.exports = __webpack_public_path__ + "img/clockicon.46dd9a0d.svg";